export const mutation_search_legal_entity = `
mutation searchLegalEntity($identifier: String!, $companyName: String!){
    searchLegalEntity(identifier: $identifier, companyName: $companyName){
        data
    }
}`;
export const mutation_search_natural_person = `
mutation searchNaturalPerson($bornDate: String!, $name: String!, $surname: String!){
    searchNaturalPerson(bornDate: $bornDate, name: $name, surname:$surname){
        data
    }
}`;
export const mutation_add_anagrafica_bancadati = `
mutation addAnagraficaBancaDati($anagraficaId: Int!, $repository: String!, $infos: String!) {
    insert_anagrafica_bancadati_one(object: {AnagraficaId: $anagraficaId, Repository: $repository, Infos: $infos}) {
        Id
        Repository
        Infos
        CreatedOn
        CreatedBy
    }
}`;